import Copy from 'components/Content/Copy/Copy';

export default Copy;
